<template>
    <div class="container">
        <Nav></Nav>
        <div class="banner">
        </div>
         <div class="bread">
            <div>
                <div class="bread-mulu">
                    <img src="../assets/images/newlist-mulu.png" alt="" @click="$router.push({path:'/'})" style="cursor:pointer">
                    <span></span>
                    <p>产品介绍</p>
                    <span></span>
                    <p class="br-name">IPEC智能课件系统</p>
                </div>
            </div>
        </div>
        <div class="con">
            <img src="../assets/images/ipec1.png" alt="">
        </div>
    <Footer></Footer>
    </div>
</template>

<script>
import Nav from '@/components/topNav.vue'
import Footer from '@/components/footer.vue'
export default {
  components: {
    Nav,
    Footer
  },
  data () {
    return {

    }
  }
}
</script>

<style scoped>
.container{
    background-color: #F7F7F7;
}
.banner{
    width: 100%;
    height: 380px;
    background: url("../assets/images/compro.png") no-repeat center;
    overflow: hidden;
}
.bread{
    width: 100%;
  height: 56px;
  background: #FBFBFB;
}
.bread div{
    width: 1200px;
    margin: 0px auto;
}
.bread .bread-mulu{
    width: 225px;
    float: left;
    line-height: 56px;
    display: flex;
    justify-content: space-between;
}
.bread .bread-mulu img{
    width:12px;
    height: 12px;
    align-self: center;
    vertical-align: 0px;
}
.bread .bread-mulu span{
    display: inline;
    width: 0px; /*  宽高设置为0，很重要，否则达不到效果 */
    height: 0px;
    border: 5px solid #727272;
    border-top-color: transparent; /*设置透明背景色*/
    border-right-color: transparent;
    border-bottom-color: transparent;
    align-self: center;
    margin-right:-15px;
}
.bread .bread-mulu .br-name{
    color: #B00000;
}
.con{
    width: 1200px;
    /* height: 800px; */
    /* background-color: orange; */
    margin: 20px auto 30px;
}
</style>



// WEBPACK FOOTER //
// src/views/companyPro.vue